import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  NavigationGuardNext,
  RouteLocationNormalized,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/chat",
    name: "chat",
    component: () => import("../views/ChatView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/memory",
    name: "memory",
    component: () => import("../views/MemoryView.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫：检查认证
// 注意：使用 Cookie-based 认证后，无法在客户端直接检查认证状态
// 我们依赖 API 的 401 响应来处理未认证的情况
// 这里只做基本的本地用户信息检查
router.beforeEach(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => {
    const userStr = localStorage.getItem("user");

    if (to.meta.requiresAuth && !userStr) {
      // 需要认证但没有本地用户信息，跳转到登录页
      next("/login");
    } else if (to.path === "/login" && userStr) {
      // 已有本地用户信息访问登录页，跳转到聊天页
      next("/chat");
    } else {
      next();
    }
  },
);

export default router;
